import type { PublicUser, User } from '@/shared/types/user'

export function urlsFromUserCosmetics(user: PublicUser | User) {
  return {
    backgroundUrl: user.background?.image?.file?.url ?? null,
    avatarUrl: user.avatar?.image?.file?.url ?? '/icons/user.svg',
    frameUrl: user.frame?.image?.file?.url ?? null
  }
}
